<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <b-col cols="8">
                        <b-row class="mb-1 ml-3 mr-1">
                            <b-col>
                                <lg-finder-page-pessoa id="finderPessoaBaixaList" label="Responsável:"
                                    :prefix="prefix + title + ' > '" title="Responsáveis" v-model="form.pessoa"
                                    invalidFeedback="Informe um responsável!" @onselect="handlePessoaSelect" />
                            </b-col>
                        </b-row>
                        <b-row class="mb-2 mr-1 ml-1">
                            <b-col cols="4">
                                <lg-form-date description='' v-model="form.dataDe" label="De:" invalidFeedback=" " />
                            </b-col>
                            <b-col cols="4" class="mx">
                                <lg-form-date description='' v-model="form.dataAte" label="Até:" invalidFeedback=" " />
                            </b-col>
                            <b-col cols="4">
                                <lg-form-select v-model="form.status" :loadFunction="statusList"
                                    labelFormGroupBind="Status:" label="descricao" description=" " filterList="true"
                                    @input="load" style="z-index: 1000;" />

                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="3" class="text-right align-self-center">
                        <b-button id="limpar" class="mb-2 mr-2" size="sm" pill variant="primary" @click="clearForm()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limpar" title="Limpar"></b-tooltip>
                        </b-button>
                        <b-button id="localizar" class="mb-2 mr-2" size="sm" pill variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizar" title="Localizar"></b-tooltip>
                        </b-button>
                        <b-button v-if="temPrivilegioInclusao()" id="novo" class="mb-2 mr-2" size="sm" pill
                            variant="secondary" @click="mostrarModal()">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
                        </b-button>
                    </b-col>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="busy" :items="records" :fields="tableFields" :hover="true"
                    show-empty @row-dblclicked="clickRow">
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template #cell(data)="row">
                        {{ formatDate(row.item.data) }}
                    </template>
                    <template #cell(editar)="row">
                        <b-button v-if="row.item.codstatus == 225 && temPrivilegioEdicao()" :id="'edit-' + row.index"
                            variant="primary" size="sm" pill @click="editar(row.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="'edit-' + row.index" title="Editar..."></b-tooltip>
                        </b-button>
                    </template>
                    <template #cell(finalizar)="row">
                        <b-button v-if="(row.item.codstatus == 225) && temPrivilegioEdicao()"
                            :id="'finalizar-' + row.index" variant="primary" size="sm" pill
                            @click="finalizar(row.item)">
                            <b-icon icon="check2-circle" />
                            <b-tooltip :target="'finalizar-' + row.index" title="Finalizar..."></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(visualizar)="row">
                        <b-button
                            v-if="row.item.codstatus == 142 || row.item.codstatus == 149 || row.item.codstatus == 143 || row.item.codstatus == 144 || row.item.codstatus == 152"
                            :id="row.index + 'visualizar-button'" class="my-2" size="sm" pill variant="primary"
                            @click="visualizar(row.item)">
                            <b-icon icon="file-earmark-text" />
                            <b-tooltip :target="row.index + 'visualizar-button'" title="Visualizar..."></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(estornar)="row">
                        <b-button v-if="row.item.situacao === 1 && row.item.podeEstornar && temPrivilegioEdicao()"
                            :id="row.index + 'estornar-button'" class="my-2" size="sm" pill variant="primary"
                            @click="estornar(row.item)">
                            <b-icon icon="arrow-left" />
                            <b-tooltip :target="row.index + 'estornar-button'" title="Estornar..."></b-tooltip>
                        </b-button>
                    </template>
                </b-table>
                <b-row class="mt-2" v-if="records && records.length">
                    <b-col cols="6" class="d-flex align-items-center" style="font-size: 12px">
                        Página {{ page }} de {{ totalPage }} - {{ total }} registros
                        <b-form-select size="sm" v-model="perPage" @change="load()" :options="perPageOptions"
                            class="ml-3"></b-form-select>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination v-model="page" :per-page="perPage" :total-rows="total"
                                style="margin-top: 10px; margin-bottom: 10px"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <BaixaItemBemConsumoForm v-if="showModal" :prefix="prefix + title + ' > '" :id="id" :isVisualizar="isVisualizar"
            @close="fecharModal" />
        <BaixaItemBemConsumoEstornoForm v-if="showModalEstorno" :prefix="prefix + title + ' > '" :id="id"
            @close="fecharModalEstorno" />
    </b-card>
</template>

<script>
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm";
import verificaPrivilegio from "@/utils/VerificaPrivilegio";
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import ResourceService from "@/core/api/ResourceService";
import moment from "moment";
import BaixaItemBemConsumoForm from "@/modules/almoxarifados/baixa-item-bem-consumo/BaixaItemBemConsumoForm.vue";
import BaixaItemBemConsumoEstornoForm
    from "@/modules/almoxarifados/baixa-item-bem-consumo/BaixaItemBemConsumoEstornoForm.vue";

export default {
    components: {
        BaixaItemBemConsumoEstornoForm,
        BaixaItemBemConsumoForm,
        LgFormSelect,
        LgFinderPagePessoa,
        LgFormDate,
    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    data() {
        return {
            title: "Baixa Item Bem Consumo",
            id: null,
            showModal: false,
            isVisualizar: false,
            showModalEstorno: false,
            page: 1,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            busy: false,
            records: [],
            total: 0,
            totalPage: 0,
            form: {
                pessoa: {},
                dataDe: "",
                dataAte: "",
                status: { id: null, descricao: "Todos" },
            },

        };
    },
    beforeMount() {
        this.$statusService = new ResourceService(`/api/status/tipo/44`);
        this.$service = new ResourceService(`/api/baixaitembemconsumo`)
        this.load()
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        tableFields() {
            return [
                { key: "data", label: "Data" },
                { key: "responsavel", label: "Responsável" },
                { key: "statusDescricao", label: "Status" },
                { key: "editar", label: "", tdClass: "w-1" },
                { key: "finalizar", label: "", tdClass: "w-1" },
                { key: "visualizar", label: "", tdClass: "w-1" },
                { key: "estornar", label: "", tdClass: "w-1" },
                { key: "xls", label: " ", tdClass: "w-1" },
            ];
        },
    },
    methods: {
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.BAIXA_ITEM_BEM_CONSUMO_EDITAR);
        },
        temPrivilegioInclusao() {
            return verificaPrivilegio(PrivilegiosEnum.BAIXA_ITEM_BEM_CONSUMO_INCLUIR);
        },
        temPrivilegioRelatorio() {
            return verificaPrivilegio(PrivilegiosEnum.RELATORIO_GERAR_BAIXA_ITEM_BEM_PERMANENTE);
        },
        handlePessoaSelect(item) {
            this.form.pessoa = item;
            this.load();
        },
        async load() {


            this.busy = true;
            const filtro = {};
            if (this.form.pessoa && this.form.pessoa.id) {
                filtro.codPessoa = this.form.pessoa.id;
            }
            if (this.form.dataDe) {
                filtro.dtInicio = moment(this.form.dataDe).format('YYYY-MM-DD[T]HH:mm:ss');
            }
            if (this.form.dataAte) {
                filtro.dtFim = moment(this.form.dataAte).format('YYYY-MM-DD[T]HH:mm:ss');
            }

            if (this.form.dataDe && this.form.dataAte) {
                const ini = new Date(this.form.dataDe);
                const fim = new Date(this.form.dataAte);

                if (ini > fim) {
                    this.busy = false;
                    this.$notify({
                        type: "danger",
                        message: "Informe as datas corretamente.",
                    });
                    return;
                }
            }

            if (this.form.status !== undefined) {
                filtro.statusParam = this.form.status.id;
            }
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            });
            this.busy = false;

        },
        clearForm() {
            this.form = {
                pessoa: {},
                dataDe: "",
                dataAte: "",
                status: { id: null, descricao: "Todos" },

                tombamento: "",
                ateTombamento: "",
                tombamentoSamp: "",
                descricao: "",
            };
            this.load();
        },
        estornar(item) {
            this.id = item.cod;
            this.showModalEstorno = true;
        },
        fecharModalEstorno() {
            this.showModalEstorno = false;
            this.id = null;
            this.load();
        },
        async statusList() {
            return this.$statusService.find();
        },
        cancelar() {
            this.id = null;
            this.isVisualizar = false;
            this.showModal = false;
            this.load();
        },
        mostrarModal() {
            this.id = null;
            this.isVisualizar = false;
            this.showModal = true;
        },
        fecharModal() {
            this.showModal = false;
            this.isVisualizar = false;
            this.id = null;
            this.load();
        },
        editar(item) {
            this.id = item.cod;
            this.isVisualizar = false;
            this.showModal = true;
        },
        visualizar(item) {
            this.id = item.cod;
            this.isVisualizar = true;
            this.showModal = true;
        },
        clickRow(item) {
            this.$emit("row-clicked", item);
        },
        formatDate(date) {
            return date ? new Date(date).toLocaleDateString() : "";
        },
    },
};
</script>
